import { StrictMode } from "react"
import { createRoot } from "react-dom/client"

import "./theme/theme.css"
import { App } from "./app/App"
import { initI18n } from "./i18n"
import { env } from "./api/env"
import { BRAND } from "./brand/brand.config"

/**
 * `index.html`'s own <title> is a generic fallback (the text a viewer sees
 * for the instant before this module runs); the real title is set here so a
 * rebrand needs no HTML edit. Same for the favicon -- injected only when one
 * is configured, never a `<link>` pointing at a file that doesn't exist.
 */
document.title = BRAND.name
if (BRAND.faviconAssetPath) {
  const link = document.createElement("link")
  link.rel = "icon"
  link.href = BRAND.faviconAssetPath
  document.head.appendChild(link)
}

async function start() {
  await initI18n()

  // `pnpm dev:mock` (LLD §12.2). The build-time check lets Vite drop the import,
  // so a build without VITE_ENABLE_MOCKS=true carries neither MSW nor faker.
  if (import.meta.env.VITE_ENABLE_MOCKS === "true" && env.enableMocks) {
    const { startMockWorker } = await import("./mocks/browser")
    await startMockWorker()
  }

  const root = document.getElementById("root")
  if (!root) throw new Error("Root element #root is missing from index.html")

  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

void start()
